import styled from "styled-components"

export const CardImageWrapper = styled.div`
    width:100%;
    height: 100%;
    padding-top: 56%;
    overflow: hidden;
    position:relative;
` 
